import { rowHeight } from './constants';
import { SideBarItem } from './types';

export type BuildTimelineRowTopsOptions = {
  topOffset: number;
  categoryGap: number;
};

export const buildTimelineRowTops = (
  rows: SideBarItem[],
  { topOffset, categoryGap }: BuildTimelineRowTopsOptions,
): number[] => {
  let currentTop = topOffset;
  let isFirstCategory = true;

  return rows.map((item) => {
    if ('lifeArea' in item) {
      if (!isFirstCategory) {
        currentTop += categoryGap;
      }
      isFirstCategory = false;
    }
    const top = currentTop;
    currentTop += rowHeight;
    return top;
  });
};
